module.exports = __webpack_public_path__ + "static/media/icon-my-orders--color-large.579a8a41.svg";